module.exports = __webpack_public_path__ + "img/light_nor_img.8191d9d4.png";